export type JsonSyntaxError = {
  message: string;
  line: number | undefined;
};

// Browsers report JSON syntax errors differently: V8 gives a character position (and sometimes
// line/column), Firefox gives line/column, Safari gives neither. Normalise to a line/column hint.
export function describeJsonError(text: string, error: unknown): JsonSyntaxError {
  const message = error instanceof Error ? error.message : String(error);

  const lineColumn = message.match(/line (\d+) column \d+/i);
  if (lineColumn) return { message, line: Number(lineColumn[1]) };

  const position = message.match(/position (\d+)/i);
  if (!position) return { message, line: undefined };

  const preceding = text.slice(0, Number(position[1])).split('\n');
  const line = preceding.length;
  return {
    message: `${message} (line ${line}, column ${preceding[preceding.length - 1].length + 1})`,
    line,
  };
}
